module.exports = __webpack_public_path__ + "static/languages-b4fa49c91c45723befd3c78d8e8e99b7.svg";